var map = {
	"./About/About.route.tsx": 817,
	"./Accounts/Accounts.route.ts": 818,
	"./Airdrop/Airdrop.route.tsx": 819,
	"./AirdropDetail/AirdropDetail.route.tsx": 820,
	"./AllLockTokenVesting/AllLockTokenVesting.route.tsx": 821,
	"./Army/Army.route.tsx": 822,
	"./Auth/Auth.route.ts": 823,
	"./Collections/Collection.list.route.tsx": 824,
	"./Collections/Collections.details.route.tsx": 825,
	"./Collections/Marketplace.route.tsx": 826,
	"./ComingSoon/ComingSoon.route.tsx": 827,
	"./Home/Home.route.tsx": 828,
	"./IframeNftIdo/IframeNftIdo.route.tsx": 829,
	"./IframeNftIdo/IframeNftItemList.route.tsx": 830,
	"./LandingPage/LandingPage.route.tsx": 831,
	"./MemberShip/MemberShip.route.tsx": 832,
	"./MintNFT/AcknoledgerINO.route.tsx": 833,
	"./MintNFT/JoinINO.route.tsx": 834,
	"./MintNFT/ListIno.route.tsx": 835,
	"./MintNFT/MetaverseNFT.route.tsx": 836,
	"./MintNFT/MintNFT.route.tsx": 837,
	"./MintNFT/NFTDetails.route.tsx": 838,
	"./MintNFT/NFTWastedLands.route.tsx": 839,
	"./NftTracking/NftTracking.route.tsx": 840,
	"./NftTracking/NftTrackingDetail.route.tsx": 841,
	"./NftTracking/WatchList.route.tsx": 842,
	"./Pool/ListPools.route.tsx": 843,
	"./Pool/Pool.route.tsx": 844,
	"./Prediction/Predict.route.tsx": 845,
	"./PrivacyPolicy/PrivacyPolicy.route.ts": 846,
	"./Refund/Refund.route.tsx": 847,
	"./StakeFarming/StakeFarming.route.tsx": 848,
	"./TermsOfService/TermsOfService.route.ts": 849,
	"./WhiteList/WhiteList.route.tsx": 850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;